import React from 'react';
import styled from 'styled-components';

interface InputProps {
  className?: string;
  fieldname: string;
  placeholder?: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const StyledInput = styled.input`
  display: block;
  border: 1px solid var(--color-input-border);
  border-radius: var(--border-radius-m);
  padding: var(--distance-xxs) var(--distance-m);
  width: 100%;
  background-color: var(--color-input-background);
  color: var(--color-input-text);
  font-size: var(--font-size-m);
  line-height: var(--line-height-xs);
  font-weight: var(--font-weight-bold);
  box-sizing: border-box;
  appearance: none;

  &:not(:placeholder-shown) {
    color: var(--color-input);
    font-size: var(--font-size-m);
    line-height: var(--line-height-xs);
  }

  &::placeholder {
    opacity: 1;
    color: var(--color-input-placeholder);
  }

  &:focus {
    background-color: var(--color-input-background-focus);
    color: var(--color-input-text);
    border: 1px solid var(--color-input-border-focus);
    outline: 2px solid var(--color-input-outline);
  }

  &:hover {
    background-color: var(--color-input-background-hover);
    color: var(--color-input-text);
    border: 1px solid var(--color-input-border-hover);
  }
`;

const Input = ({
  onChange,
  className,
  fieldname,
  placeholder,
  required = true,
  minLength,
  maxLength,
  pattern,
}: InputProps) => {
  return (
    <StyledInput
      autoComplete={'off'}
      className={className}
      type="text"
      name={fieldname}
      placeholder={placeholder}
      id={fieldname}
      required={required}
      minLength={minLength}
      maxLength={maxLength}
      pattern={pattern}
      onChange={onChange}
    />
  );
};

export default Input;
